// extracted by mini-css-extract-plugin
export default {"container":"IndustryNewsPage_container__tXDG9","dark":"IndustryNewsPage_dark__tMSVF","light":"IndustryNewsPage_light__x-3Vp"};